module.exports = __webpack_public_path__ + "img/show-pass.3a10ca84.svg";